import { useState, SyntheticEvent } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Certificate } from "../../Certificate";
import MainForm from "./MainForm";
import SearchResult from "./SearchResult";

export default function Main() {
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    totalInput: 0,
    text: "",
  });

  const datePairError = (
    certificate: Certificate,
    requireDatePath: boolean
  ): string => {
    const hasDate = Boolean(certificate.date?.trim());
    const hasInvoiceDate = Boolean(certificate.date_invoice?.trim());
    const hasCertNumber = Boolean(certificate.certification_number?.trim());
    const hasGovNumber = Boolean(certificate.gov_number?.trim());

    if (requireDatePath && !hasDate && !hasInvoiceDate) {
      return "заполните дату выпуска сертификата или дату выпуска накладной";
    }
    if (hasDate && !hasCertNumber) {
      return "укажите номер сертификата";
    }
    if (hasInvoiceDate && !hasGovNumber) {
      return "укажите номер вагона (гос. номер)";
    }
    return "";
  };

  const companyFormError = (certificate: Certificate): string => {
    const hasDate = Boolean(certificate.date?.trim());
    const hasInvoiceDate = Boolean(certificate.date_invoice?.trim());
    const hasCertNumber = Boolean(certificate.certification_number?.trim());
    const hasInvoiceExtra = Boolean(
      certificate.gov_number?.trim() ||
        certificate.delivery_number?.trim() ||
        certificate.invoice_number?.trim() ||
        certificate.contractor?.trim()
    );

    if (hasDate && !hasCertNumber) {
      return "укажите номер сертификата";
    }
    if (hasInvoiceDate && !hasInvoiceExtra) {
      return "укажите номер вагона, поставки, накладной или ИНН контрагента";
    }

    let totalInput = 0;
    Object.values(certificate).forEach((val: any) => {
      if (val !== undefined && val !== 0 && val !== "") {
        totalInput++;
      }
    });
    if (totalInput < 2) {
      return "минимум 2 поля должны быть заполнены";
    }
    return "";
  };

  const handleSubmit = (
    event: SyntheticEvent,
    data: Certificate,
    recaptchaRef: React.RefObject<ReCAPTCHA>,
    isInternal: boolean
  ) => {
    event.preventDefault();
    setLoading(true);
    setCertificates([]);

    const formError = isInternal
      ? companyFormError(data)
      : datePairError(data, true);
    if (formError) {
      setErrors({ totalInput: 0, text: formError });
      setLoading(false);
      return;
    }
    setErrors({ totalInput: 0, text: "" });

    const rec = recaptchaRef.current;
    const recaptchaValue = rec?.getValue();
    let formData = { ...data, r: recaptchaValue };

    fetch("/api/submit", {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        // console.log(formData);
        rec?.reset();
        setLoading(false);
        if (res.status === 401) {
          setErrors((err) => ({
            ...err,
            text: "пройдите, пожалуйста, проверку",
          }));
        }
        if (res.status === 400) {
          setErrors((err) => ({
            ...err,
            text: "Сертификат не найден. Проверьте правильность введенных данных или повторите запрос позднее.",
          }));
        }
        if (res.status === 403) {
          setErrors((err) => ({
            ...err,
            text: "Минимум 2 поля должны быть заполнены",
          }));
        }

        return res.json();
      })
      .then((res) => {
        setCertificates(res);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const validate = (certificate: Certificate, isInternal: boolean) => {
    const text = isInternal
      ? companyFormError(certificate)
      : datePairError(certificate, true);
    setErrors({ totalInput: 0, text });
  };

  return (
    <main className="flex flex-col items-center text-center px-[5%] pt-20 mb-10">
      <h2 className="text-xl text-[26px] font-bold pb-8">
        Здесь вы можете скачать сертификат качества продукции <br />
        или проверить его подлинность.
      </h2>
      <span className="text-lg pb-8 text-[20px]">
        Заполните форму для поиска сертификата. Поля, отмеченные
        <span className="text-red-600"> *</span>, обязательны для заполнения.{" "}
        <br />
        Если указана дата выпуска сертификата — нужен номер сертификата.
        Если дата выпуска накладной — номер вагона (гос. номер).
      </span>
      <MainForm loading={loading} validate={validate} onSubmit={handleSubmit} />
      {errors.text && !loading && (
        <div className="text-red-600 pt-12">{errors.text}</div>
      )}
      {loading && (
        <img
          src="/assets/loading.svg"
          className="h-[75px] w-[75px]"
          alt="loading"
        />
      )}
      {!errors.text && !loading && certificates.length !== 0 && (
        <div className="w-full lg:w-[63%] pt-4">
          <div className=" text-green-600">сертификаты найдены</div>
          <SearchResult certificates={certificates} />
        </div>
      )}
    </main>
  );
}
